import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getCompanyApiData, getConsignmentApiData, getFinacialInvoiceApiData } from 'services/MachshipService'

export const getCompanyData = createAsyncThunk('machship/data/getCompanyData', async data => {
    const response = await getCompanyApiData(data)
    return response.data
})

export const getConsignmentData = createAsyncThunk('machship/data/getConsignmentData', async data => {
    const response = await getConsignmentApiData(data)
    return response.data
})

export const getFinacialInvoiceData = createAsyncThunk('machship/data/getFinacialInvoiceData', async data => {
    const response = await getFinacialInvoiceApiData(data)
    return response.data
})

const initialTableData = {
    total: 0,
    pageIndex: 1,
    pageSize: 100,
    query: '',
    selectedTab: '',
    sort: [{ column: '', dir: '' }],
    filters: {
        company_name: '',
        carrier_and_service_name: '',
        tracking_status_name: '',
        created_date_from: '',
        created_date_to: '',
        completed_date_status: null, // null, true (Yes), false (No)
    },
}

// Company table has different filters
const initialCompanyTableData = {
    total: 0,
    pageIndex: 1,
    pageSize: 100,
    query: '',
    selectedTab: '',
    sort: [{ column: '', dir: '' }],
    filters: {
        name: '', // Company name filter
        account_code: '', // Account code filter
        display_name: '', // Display name filter
        parent_company_name: '', // Filter by parent company (if needed)
    },
}

const dataSlice = createSlice({
    name: 'machship/data',
    initialState: {
        loading: false,
        companyData: [],
        consignmentData: [],
        finacialInvoiceData: [],
        companyTableData: initialCompanyTableData,
        consignmentTableData: initialTableData,
        finacialInvoiceTableData: initialTableData,
    },
    reducers: {
        setCompanyData: (state, { payload }) => {
            state.companyData = payload
        },
        setConsignmentData: (state, { payload }) => {
            state.consignmentData = payload
        },
        setFinacialInvoiceData: (state, { payload }) => {
            state.finacialInvoiceData = payload
        },
        setCompanyTableData: (state, { payload }) => {
            state.companyTableData = payload
        },
        setConsignmentTableData: (state, { payload }) => {
            state.consignmentTableData = payload
        },
        setFinacialInvoiceTableData: (state, { payload }) => {
            state.finacialInvoiceTableData = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getCompanyData.pending, state => {
                state.loading = true
                state.companyTableData.total = 0
            })
            .addCase(getCompanyData.fulfilled, (state, { payload }) => {
                console.log('getCompanyData.fulfilled - payload:', payload)
                console.log('getCompanyData.fulfilled - results count:', payload?.results?.length)
                state.loading = false
                state.companyData = payload?.results
                state.companyTableData.total = payload?.count
                console.log('getCompanyData.fulfilled - updated state.companyData:', state.companyData)
            })
            .addCase(getCompanyData.rejected, state => {
                state.loading = false
                state.companyData = []
            })
            .addCase(getConsignmentData.pending, state => {
                state.loading = true
                state.consignmentTableData.total = 0
            })
            .addCase(getConsignmentData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.consignmentData = payload?.results
                state.consignmentTableData.total = payload?.count
            })
            .addCase(getConsignmentData.rejected, state => {
                state.loading = false
                state.consignmentData = []
            })
            .addCase(getFinacialInvoiceData.pending, state => {
                state.loading = true
                state.finacialInvoiceTableData.total = 0
            })
            .addCase(getFinacialInvoiceData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.finacialInvoiceData = payload?.results
                state.finacialInvoiceTableData.total = payload?.count
            })
            .addCase(getFinacialInvoiceData.rejected, state => {
                state.loading = false
                state.finacialInvoiceData = []
            })
    },
})

export const {
    setCompanyData,
    setConsignmentData,
    setFinacialInvoiceData,
    setCompanyTableData,
    setConsignmentTableData,
    setFinacialInvoiceTableData,
} = dataSlice.actions

export default dataSlice.reducer
